// removed by extract-text-webpack-plugin
module.exports = {"HeaderItem":"src-components-HeaderItem----headerItem-module---HeaderItem---9cRP9","active":"src-components-HeaderItem----headerItem-module---active---1MnxB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderItem/headerItem.module.css
// module id = 36
// module chunks = 77196258398326 114276838955818 155911550660936 192279678295350